export default {_name:'checkbox',module:'Field',view:'Element/Field/Check',options:{xs:12,sm:3},mobileOptions:{ms:3}}